import React, {Component} from 'react';

export default class Html extends Component {
    render() {
        const {assets} = this.props;
        const html = {__html: this.props.content};
        const iframeStyle = {
            display: "none",
            visibility: "hidden"
        };

        return (
            <html>
            <head>
                <meta charSet="utf-8"/>
                <meta name="description"
                      content="Social Native automates the process of creating high-performing branded content at scale. We measure content engagements to provide data-driven insights that help inform branded content strategy."/>
                <meta name="viewport" content="width=device-width, initial-scale=1"/>

                <title>Social Native</title>

                <link rel="shortcut icon" href="" type="image/x-icon"/>
                <link rel="icon" type="image/png" href={require('images/favicon.ico')}/>
                {__PROD && <link rel="stylesheet" href={`/main.css?${new Date().valueOf()}`}/> }
            </head>
            <body>
                <noscript>
                    <iframe
                        src="https://www.googletagmanager.com/ns.html?id=GTM-TZJ3J5B"
                        height="0"
                        width="0"
                        style={iframeStyle}
                    />
                </noscript>
                <div id="root" dangerouslySetInnerHTML={html}></div>

                <script src={assets.main}></script>
                </body>
            </html>
        );
    }
}



// WEBPACK FOOTER //
// ./web/js/launch_html.js